import React from 'react'
import CalendarioGd from '../components/CalendarioGd'

const calendario = () => {
  return (
    <CalendarioGd />
  )
}

export default calendario